export default function (ModalService) {
    return function (vehicleId, mileage, keepers) {
        return ModalService.showModal({
            controller: require('../../controllers/mileages/edit/editMileageCtrl'),
            template: require('../../controllers/mileages/edit/edit-mileage.html'),
            controllerAs: 'editMileage',
            inputs: {
                vehicleId,
                mileage,
                keepers
            }
        });
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/mileages/openEditMileageModal.js